import axios from './util/axios.js'

export function searchStyleColorSections (name, autosuggest) {
  return axios.get('/api/stylecolorsections/search/', { params: { name, autosuggest } })
}
